const Links = {
    TERMINAL_CONTACT_US: "https://www.bloomberg.com/feedback",
    BUSINESSWEEK_CONTACT_US: "http://www.businessweek.com/service",
    SUBSCRIPTION_FAQ: "https://www.bloomberg.com/notices/help",
    FACEBOOK_LINK: "https://www.facebook.com/bloombergbusiness",
    INSTAGRAM_LINK: "https://www.instagram.com/bloombergbusiness",
    TWITTER_LINK: "https://twitter.com/Business"
};

export default Links;
